import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FileText, Container } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { CarrierDocuments } from './CarrierDocuments';
import { CargoDocumentsPanel } from '../cargo/CargoDocumentsPanel';

const TABS = [['carrier', 'Carrier documents', FileText], ['cargo', 'Cargo documents', Container]];

// Documents workspace for one booking: carrier-issued PDFs and the exporter's cargo document set side by side.
export function DocumentsWorkspace({ bookings, basePath, initialBookingId }) {
  const location = useLocation();
  const [bookingId, setBookingId] = useState(location.state?.bookingId || initialBookingId || '');
  const [tab, setTab] = useState(location.state?.tab || 'carrier');
  const eligible = bookings.filter(function (b) { return b.status !== 'cancelled'; });

  return (
    <div className="bg-white rounded-sm shadow-card p-6" data-testid="documents-workspace">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-5">
        <div>
          <h2 className="text-lg font-medium text-ink flex items-center gap-2"><FileText className="h-5 w-5 text-blue-600" /> Shipment documents</h2>
          <p className="text-sm text-gray-600 mt-1">Carrier documents issued by Südvik Line, and the exporter's cargo document set — invoice, packing list, certificates and request packs — generated from the bill of lading.</p>
        </div>
        <Select value={bookingId} onValueChange={setBookingId}>
          <SelectTrigger className="h-11 rounded-sm md:w-96" data-testid="carrier-docs-booking-select"><SelectValue placeholder={eligible.length ? 'Select a booking (' + eligible.length + ')' : 'No bookings yet'} /></SelectTrigger>
          <SelectContent>
            {eligible.map(function (b) { return <SelectItem key={b.id} value={b.id}>{b.booking_number} — {b.origin_port.split(',')[0]} to {b.destination_port.split(',')[0]}</SelectItem>; })}
          </SelectContent>
        </Select>
      </div>
      <div className="flex gap-1 border-b border-gray-200 mb-5" role="tablist" data-testid="documents-tabs">
        {TABS.map(function (t) {
          const I = t[2];
          const active = tab === t[0];
          return (
            <button key={t[0]} type="button" role="tab" aria-selected={active} onClick={function () { setTab(t[0]); }} data-testid={'documents-tab-' + t[0]}
              className={'inline-flex items-center gap-2 px-4 py-2.5 text-sm -mb-px border-b-2 transition-colors duration-[120ms] ' + (active ? 'border-ink text-ink font-medium' : 'border-transparent text-gray-600 hover:text-ink')}>
              <I className="h-4 w-4" strokeWidth={1.75} /> {t[1]}
            </button>
          );
        })}
      </div>
      {tab === 'carrier' ? <CarrierDocuments bookings={bookings} basePath={basePath} controlledBookingId={bookingId} hideSelector /> : <CargoDocumentsPanel bookingId={bookingId} onOpenCarrier={function () { setTab('carrier'); }} />}
    </div>
  );
}
